import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, LockIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../../data/comparison';
import { SectionIntro } from '../layout/SectionIntro';
export function TemplateVsCustom() {
  return <section id="comparison" className="relative overflow-hidden bg-mist-50 py-16 text-navy-900 lg:py-24" data-id="element-342" data-mp="2lz8s24jtcgyt">
      <div className="absolute inset-0 bp-light" aria-hidden="true" data-id="element-343" data-mp="2zyrzev4svoa2" />
      <div className="absolute inset-x-0 top-0 h-24 bg-ink" style={{
      clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 100%)'
    }} aria-hidden="true" data-id="element-344" data-mp="2v1i1ss79c6b5" />

      <div className="relative mx-auto max-w-8xl px-5 sm:px-8 lg:px-10" data-id="element-345" data-mp="39rp8ybrte2wj">
        <SectionIntro tone="light" eyebrow="Comparison" title={<>
              A builder gets you a website.
              <span className="block text-navy-500" data-id="element-347" data-mp="3drzoog5es7ol">A custom plan gets you a business asset.</span>
            </>} body="We are not against templates on principle. We are against paying every month for a ceiling you will hit in year two." data-id="element-346" data-mp="34rl45j09qwm5" />

        {/* the wall / the build */}
        <div className="mt-12 grid gap-4 lg:grid-cols-2 lg:gap-6" data-id="element-348" data-mp="156o4w47p379t">
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.45
        }} className="relative overflow-hidden rounded-2xl border border-navy-900/10 bg-white p-6 sm:p-7" data-id="element-349" data-mp="1a60qymqqsabc">
            <div className="flex items-center justify-between" data-id="element-350" data-mp="1nx5it2nvbyb4">
              <div data-id="element-351" data-mp="1nzrthb622txk">
                <p className="font-mono text-[9.5px] uppercase tracking-[0.22em] text-navy-500" data-id="element-352" data-mp="1sx1od6c7rxss">Option A</p>
                <h3 className="mt-2 font-display text-xl font-extrabold text-navy-900/75" data-id="element-353" data-mp="1xweafov9h0ub">The template wall</h3>
              </div>
              <span className="flex items-center gap-1.5 rounded-full bg-navy-900/[0.06] px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-navy-600" data-id="element-354" data-mp="21xq2s25is067">
                <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-355" data-mp="3tzj0b02q3928" />
                Fixed
              </span>
            </div>

            <div className="mt-6 grid grid-cols-4 gap-2 sm:grid-cols-6" data-id="element-356" data-mp="bljssyo4ibv3">
              {Array.from({
              length: 18
            }).map((_, i) => <div key={i} className="aspect-[4/3] rounded-md bg-navy-900/[0.07] p-1.5" data-id="element-357" data-mp="6s764u308f4z" data-mpi={i}>
                  <div className="h-1.5 w-2/3 rounded bg-navy-900/10" data-id="element-358" data-mp="ll0yhg3dkpr2" />
                  <div className="mt-1 h-1 w-full rounded bg-navy-900/[0.07]" data-id="element-359" data-mp="gjbm9x4f261e" />
                  <div className="mt-1 h-1 w-3/4 rounded bg-navy-900/[0.07]" data-id="element-360" data-mp="uil22vopmy4u" />
                </div>)}
            </div>
            <p className="mt-5 text-[13.5px] leading-relaxed text-navy-700/75" data-id="element-361" data-mp="qisog4kgm1sm">
              Eighteen tiles, one layout, every business in your category using it. Every change you need is a workaround, an
              add-on, or a no.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.45,
          delay: 0.08
        }} className="relative overflow-hidden rounded-2xl bg-ink p-6 shadow-lift sm:p-7" data-id="element-362" data-mp="2i6qrodl9fv6t">
            <div className="absolute inset-0 bp opacity-80" aria-hidden="true" data-id="element-363" data-mp="2dcw7l91qte77" />
            <span className="absolute inset-x-0 top-0 h-[3px] bg-forge-orange" aria-hidden="true" data-id="element-364" data-mp="1yfwux6s1av5v" />
            <div className="relative flex items-center justify-between" data-id="element-365" data-mp="23i4dwgba7bhp">
              <div data-id="element-366" data-mp="1phjvhl9a3hoq">
                <p className="font-mono text-[9.5px] uppercase tracking-[0.22em] text-forge-cyan" data-id="element-367" data-mp="1pi394prwbjwy">Option B</p>
                <h3 className="mt-2 font-display text-xl font-extrabold text-white" data-id="element-368" data-mp="1ug4uxigphxc4">Your custom WebsiteForge build</h3>
              </div>
              <span className="rounded-full bg-forge-green/15 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-forge-green" data-id="element-369" data-mp="3otw3sfr7od6i">
                Modular
              </span>
            </div>

            <div className="relative mt-6 grid grid-cols-4 grid-rows-4 gap-2 sm:grid-cols-6" data-id="element-370" data-mp="1jstc0nhyhxhl">
              <Module className="col-span-2 row-span-2 border-forge-orange/40 bg-forge-orange/10" label="Home & offers" data-id="element-371" data-mp="1etgsocqan8jr" />
              <Module className="col-span-2 border-forge-cyan/40 bg-forge-cyan/10" label="Service pages" data-id="element-372" data-mp="1asn199dn7bm4" />
              <Module className="col-span-2 row-span-3 border-forge-green/40 bg-forge-green/10" label="Ecommerce" data-id="element-373" data-mp="15t25t8xolle5" />
              <Module className="col-span-2 border-white/15 bg-white/[0.05]" label="Lead paths" data-id="element-374" data-mp="111abqofbgxj9" />
              <Module className="col-span-2 border-white/15 bg-white/[0.05]" label="CMS" data-id="element-375" data-mp="w3qy9qqg0osd" />
              <Module className="col-span-2 border-forge-cyan/40 bg-forge-cyan/10" label="Integrations" data-id="element-376" data-mp="r4xgvn81cdmx" />
              <Module className="col-span-2 border-white/15 bg-white/[0.05]" label="SEO structure" data-id="element-377" data-mp="n0zixfug58vg" />
              <Module className="col-span-2 border-white/15 bg-white/[0.05]" label="Hosting & support" data-id="element-378" data-mp="i4it8h7lmmg9" />
              <Module className="col-span-2 border-forge-orange/40 bg-forge-orange/10" label="Whatever comes next" data-id="element-379" data-mp="2tq1gy29u3w9o" />
            </div>
            <p className="relative mt-5 text-[13.5px] leading-relaxed text-mist-300" data-id="element-380" data-mp="2yrh4q23ecgvr">
              Modules sized to the work they do. Add a channel, a product line, or an integration and the build extends
              instead of breaking.
            </p>
          </motion.div>
        </div>

        {/* seam rows */}
        <div className="mt-6 overflow-hidden rounded-2xl border border-navy-900/10 bg-white" data-id="element-381" data-mp="2f1do43rdi0nf">
          {comparisonRows.map((row, i) => <motion.div key={row.topic} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.35,
          delay: i * 0.04
        }} className={`grid gap-3 px-5 py-5 sm:px-7 lg:grid-cols-12 lg:items-center lg:gap-6 ${i !== comparisonRows.length - 1 ? 'border-b border-navy-900/[0.08]' : ''}`} data-id="element-382" data-mp="2jzyhpkc4dm2w" data-mpi={i}>
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-navy-500 lg:col-span-2" data-id="element-383" data-mp="2unrulxdci7vu">{row.topic}</p>
              <div className="flex gap-3 lg:col-span-5" data-id="element-384" data-mp="38d3fsxzuzbnm">
                <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-navy-900/[0.07]" data-id="element-385" data-mp="34d1nhfg0jul0">
                  <XIcon className="h-3 w-3 text-navy-600" aria-hidden="true" data-id="element-386" data-mp="2gmfenly6q69y" />
                </span>
                <p className="text-[13.5px] leading-relaxed text-navy-700/70" data-id="element-387" data-mp="2bow1yqh4y1k4">{row.template}</p>
              </div>
              <div className="flex gap-3 rounded-xl bg-navy-900/[0.03] px-4 py-3 lg:col-span-5" data-id="element-388" data-mp="2pooo08hpvtlr">
                <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-forge-green/15" data-id="element-389" data-mp="2ko0yjr94zktn">
                  <CheckIcon className="h-3 w-3 text-forge-green" aria-hidden="true" data-id="element-390" data-mp="4w3ceagwjp67" />
                </span>
                <p className="text-[13.5px] font-medium leading-relaxed text-navy-900" data-id="element-391" data-mp="3w3po8qdryxy5">{row.custom}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-6 flex flex-col items-start gap-4 rounded-2xl bg-navy-900 px-6 py-7 sm:flex-row sm:items-center sm:justify-between lg:px-9" data-id="element-392" data-mp="ci8mfzsn4qne">
          <p className="max-w-2xl font-display text-[17px] font-bold leading-snug text-white" data-id="element-393" data-mp="3ghfkrmd6dry">
            Not sure which side of the line your current site is on? Send it over and we will tell you straight.
          </p>
          <Link to="/pricing-plan" className="group inline-flex shrink-0 items-center gap-2 rounded-xl bg-forge-orange px-5 py-3 text-[14px] font-bold text-ink transition-transform hover:-translate-y-0.5" data-id="element-394" data-mp="w5obrjycira1">
            See pricing plans
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-395" data-mp="md0kf4q4xfip" />
          </Link>
        </div>
      </div>
    </section>;
}
function Module({
  className,
  label
}: {
  className: string;
  label: string;
}) {
  return <div className={`flex items-end rounded-lg border p-2.5 ${className}`} data-id="element-396" data-mp="3b0dgkud0p9cw">
      <span className="text-[10.5px] font-semibold leading-tight text-white/90" data-id="element-397" data-mp="36716rqczz747">{label}</span>
    </div>;
}